<template>
	<div class="d-flex">
		<a-button @click="show" icon="setting">
			Manage Groups
		</a-button>

		<a-modal
			title="Manage Groups"
			:visible="visible"
			@cancel="hide"
			:footer="null"
		>
			<a-row>
				<a-col :span="24">
					<div class="text-uppercase text-dark font-size-15 font-weight-bold">
						CREATE
					</div>
					<account-group-create />
				</a-col>
				<a-col :span="24">
					<div class="text-uppercase text-dark font-size-15 font-weight-bold">
						DELETE
					</div>
					<div class="p-2 bg-gray-2">
						<account-group-delete />
					</div>
				</a-col>
			</a-row>
		</a-modal>
	</div>
</template>

<script>
import AccountGroupCreate from '@/components/widgets/AccountGroup/Create'
import AccountGroupDelete from '@/components/widgets/AccountGroup/Delete'

export default {
	name: 'AccountManageGroups',
	components: {
		AccountGroupCreate,
		AccountGroupDelete,
	},
	data: function() {
		return {
			visible: false,
		}
	},
	methods: {
		show() {
			this.visible = true
		},
		hide() {
			this.visible = false
		},
	},
}
</script>

<style></style>
